<template>
    <b-modal ref="modal" :title="title">
        <b-row class="align-items-center">
            <b-col cols="4" v-if="this.product.gallery.length">
                <img :src="imageUrl(this.product.gallery[0].image)" :alt="product.nome" :title="product.nome" :class="$wdconfig.modules.product.image_object_fit" loading="lazy"/>
            </b-col>
            <b-col>
                {{ product.name }}
            </b-col>
        </b-row>
        <template #modal-footer="{ ok, cancel, hide }">
            <nuxt-link class="btn-default text-uppercase" to="/conta/lista-de-presentes/">
                Ir para a lista
            </nuxt-link>
        </template>
    </b-modal>
</template>
<script>
    import utils from '~/mixins/utils';

    export default {
        mixins: [
            utils
        ],
        props: {
            title: {
                default: ''
            },
            product: {
                default: () => {}
            }
        },
        data() {
            return {

            }
        },
        methods: {
            show() {
                this.$refs['modal'].show()
            },
            hide() {
                this.$refs['modal'].hide()
            }
        }
    }
</script>
